import { Component, Input, OnInit } from '@angular/core';
import { PIMLevelEnum } from '@inventory/pages/manage-non-usf-products/models/non-usf-products-view-model';
import { IonNav } from '@ionic/angular';
import { PlatformEnum } from '@panamax/app-state';
import { HierarchyDto } from '@usf/product-types';

@Component({
  selector: 'app-pim-selection-modal',
  templateUrl: './pim-selection-modal.component.html',
  styleUrls: ['./pim-selection-modal.component.scss'],
})
export class PimSelectionModalComponent implements OnInit {
  @Input() level: PIMLevelEnum;
  @Input() heirarchyData: HierarchyDto[];
  @Input() callbackSaveChange: Function;
  @Input() dismissFunction: Function;
  @Input() searchPlaceholder: string;
  @Input() platform: PlatformEnum;
  @Input() title: string;
  @Input() initialSelection: HierarchyDto;
  platformRef = PlatformEnum;
  selection: HierarchyDto;

  searchKey: string;
  searchableHeirarchyData: HierarchyDto[] = [];
  constructor(private ionNav: IonNav) {}

  ngOnInit(): void {
    this.resetSearch();
    if (this.initialSelection) this.selection = { ...this.initialSelection };
  }

  sortAZ = (a, b) => {
    if (a.description?.toUpperCase() > b.description?.toUpperCase()) {
      return 1;
    } else if (a.description?.toUpperCase() < b.description?.toUpperCase()) {
      return -1;
    }
    return 0;
  };

  filterByKey = heiararchy => {
    return (
      heiararchy.code?.toUpperCase()?.includes(this.searchKey?.toUpperCase()) ||
      heiararchy.description
        ?.toUpperCase()
        ?.includes(this.searchKey?.toUpperCase())
    );
  };

  resetSearch = () => {
    this.searchKey = '';
    this.searchableHeirarchyData = this.heirarchyData?.sort(this.sortAZ) ?? [];
  };

  handleRadioSelection = $event => {
    const heirarchyCode: string = $event?.detail?.value;

    if (heirarchyCode && heirarchyCode !== this.selection?.code) {
      this.selection = this.heirarchyData?.find(
        item => item.code === heirarchyCode,
      );
    } else {
      this.selection = undefined;
    }
  };

  handleSearch = () => {
    this.searchableHeirarchyData = this.heirarchyData
      ?.filter(this.filterByKey)
      ?.sort(this.sortAZ);
  };

  onSave() {
    this.callbackSaveChange(this.level, this.selection);
    this.ionNav.pop();
  }

  goBack() {
    this.ionNav.pop();
  }

  dismiss() {
    this.dismissFunction();
  }
}
